module.exports = __webpack_public_path__ + "img/5Games.fffe41eb.jpg";